import {
  Component,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  signal,
  WritableSignal,
} from '@angular/core';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { ColorService } from '../../../services/color.service';
import { IconType } from '@kinomap-dev/ng-ui-lib/core';
import { TranslatePipe } from '@ngx-translate/core';

export type FilterMenuElementItem = {
  icon: IconType;
  name: string;
  id: string;
  disabled?: boolean;
};

@Component({
  selector: 'ul[app-filter-menu-element]',
  imports: [IconComponent, TranslatePipe],
  template: `
    @for (element of elements(); track $index) {
      <li
        [class.active]="activeElementId() === element.id"
        [class.disabled]="element.disabled"
        [attr.aria-disabled]="element.disabled || null"
        (click)="!element.disabled && onElementClick.emit(element.id)"
        (mouseenter)="hoveredIndex.set($index)"
        (mouseleave)="hoveredIndex.set(null)"
      >
        <kin-icon
          [name]="element.icon"
          [color]="
            element.disabled
              ? colorService.neutral300()
              : activeElementId() === element.id || hoveredIndex() === $index
                ? colorService.neutral900()
                : colorService.neutral500()
          "
        />
        <p>{{ element.name | translate }}</p>
      </li>
    }
  `,
  styleUrl: './filter-menu-element.scss',
})
export class FilterMenuElement {
  readonly colorService: ColorService = inject(ColorService);

  hoveredIndex: WritableSignal<number | null> = signal(null);
  elements: InputSignal<FilterMenuElementItem[]> = input.required();
  activeElementId: InputSignal<string | undefined> = input<string | undefined>();
  onElementClick: OutputEmitterRef<string> = output();
}
